import React from 'react';
import { Sparkles } from 'lucide-react';

interface SectionDividerProps {
  sectionName?: string;
}

const SectionDivider: React.FC<SectionDividerProps> = ({ sectionName }) => {
  return (
    <div className="relative w-full py-4 sm:py-5 flex items-center justify-center overflow-hidden pointer-events-none px-4 bg-white">
      <div className="w-full max-w-5xl mx-auto flex items-center justify-center relative">
        {/* Left Fading Line */}
        <div className="flex-1 h-[1.5px] bg-gradient-to-r from-transparent via-violet-300 to-violet-500/80"></div>

        {/* Center Pill with Section Name */}
        {sectionName ? (
          <div className="mx-4 sm:mx-6 px-5 py-1.5 rounded-full border border-violet-200 bg-white shadow-md shadow-violet-500/5 flex items-center gap-2">
            <Sparkles size={13} className="text-violet-600 animate-pulse" />
            <span className="text-[11px] font-extrabold uppercase tracking-[0.25em] text-violet-950">
              {sectionName}
            </span>
          </div>
        ) : (
          <div className="mx-4 p-1.5 rounded-full border border-violet-200 bg-white shadow-md shadow-violet-500/5 flex items-center justify-center">
            <Sparkles size={13} className="text-violet-600 animate-pulse" />
          </div>
        )}

        {/* Right Fading Line */}
        <div className="flex-1 h-[1.5px] bg-gradient-to-l from-transparent via-violet-300 to-violet-500/80"></div>
      </div>
    </div>
  );
};

export default SectionDivider;
